/**
 * Minimalist Theme
 * Ultra-clean Midday-inspired design with monochromatic palette
 */

export const minimalistTheme = {
  theme_name: 'Minimalist',
  theme_description:
    'Ultra-clean Midday-inspired design with monochromatic palette',
  vibe: 'Clean & Simple',

  // Core colors matching Midday
  primary_color: '#000000',
  secondary_color: '#525252',
  accent_color: '#A1A1A1',
  background_color: '#FFFFFF', // Pure white background
  surface_color: '#FFFFFF', // Pure white for cards
  text_color: '#0A0A0A', // Near-black text

  // Extended colors for better control
  text_secondary: '#737373',
  text_muted: '#A1A1A1',
  divider_color: '#E5E5E5',
  sidebar_background: '#FFFFFF',
  sidebar_text: '#525252',
  card_background: '#FFFFFF',

  // Semantic Status Colors (subtle monochromatic variants)
  success_color: '#4caf50',
  error_color: '#f44336',
  warning_color: '#ff9800',
  info_color: '#2196f3',

  // Typography - Inter font family for modern look
  font_family:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  font_size: '14px',
  heading_font_size: '2rem', // Increased from 1.5rem for better readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout
  border_radius: 8, // Subtle rounded corners
  spacing_unit: 8,

  // Assets
  logo_url: '',
  favicon_url: '',
  // Custom CSS for Midday-style components
  custom_css: ``,
  // Status
  is_active: false,
  status: 'inactive',
};

export default minimalistTheme;
